import { createI18n, useI18n } from 'vue-i18n'
import { getHashQueryParams } from '@/lib/utils'
import { computed } from 'vue'
import TranslateService from '@/api/translate.js'

const queryParams = getHashQueryParams()
// 获取当前语言设置 默认取app传入的 再取本身有的 再取默认的英文
const lang = queryParams?.lang || 'en'
const i18n = createI18n({
  legacy: false,
  locale: lang,
  fallbackLocale: 'en',
  messages: {},
})

// 异步加载语言文件
export const loadLocale = async (lang) => {
  // 并行加载
  await Promise.allSettled([
    // 多语言加载
    (async () => {
      if (!i18n.global.availableLocales.includes(lang)) {
        const localeFile = await import(`./locales/${lang}.json`)
        i18n.global.setLocaleMessage(lang, localeFile.default)
        if (lang !== 'en') {
          const enLocale = await import(`./locales/en.json`)
          i18n.global.setLocaleMessage('en', enLocale.default)
        }
      }
    })(),
    // 错误码翻译
    TranslateService.getCommonErrorTranslate(lang)
      .then((data) => {
        for (const key in data) {
          i18n.global.mergeLocaleMessage(lang, data[key])
        }
      })
      .catch((error) => {
        console.warn('Error translations skipped:', error)
      }),
  ])
}

export const $t = i18n.global.t

export const setDocumentTitle = async (key) => {
  await loadLocale(lang)
  document.title = $t(key || 'hf_web_app_title_name')
}

export default i18n

export const LanguageOption = [
  {
    id: 0,
    label: 'English',
    key: 'en',
  },
  {
    id: 1,
    label: 'Italiano',
    key: 'it',
  },
  {
    id: 2,
    label: 'Español',
    key: 'es',
  },
  {
    id: 3,
    label: 'Deutsch',
    key: 'de',
  },
  {
    id: 4,
    label: 'Français',
    key: 'fr',
  },
  {
    id: 5,
    label: 'Polski',
    key: 'pl',
  },
  {
    id: 6,
    label: 'Nederlands',
    key: 'nl',
  },
  {
    id: 7,
    label: 'Български',
    key: 'bg',
  },
  {
    id: 8,
    label: 'Český',
    key: 'cs',
  },
  {
    id: 9,
    label: 'Dansk',
    key: 'da',
  },
  {
    id: 10,
    label: 'Suomi',
    key: 'fi',
  },
  {
    id: 11,
    label: 'Magyar',
    key: 'hu',
  },
  {
    id: 12,
    label: 'Português',
    key: 'pt',
  },
  {
    id: 13,
    label: 'Eesti',
    key: 'et',
  },
  {
    id: 14,
    label: 'Hrvatski',
    key: 'hr',
  },
  {
    id: 15,
    label: 'Ελληνικά',
    key: 'el',
  },
  {
    id: 16,
    label: 'Norsk',
    key: 'no',
  },
  {
    id: 17,
    label: 'Latviešu',
    key: 'lv',
  },
  {
    id: 18,
    label: 'Lietuvių',
    key: 'lt',
  },
  {
    id: 19,
    label: 'Română',
    key: 'ro',
  },
  {
    id: 20,
    label: 'Русский',
    key: 'ru',
  },
  {
    id: 21,
    label: 'Svenska',
    key: 'sv',
  },
  {
    id: 22,
    label: 'Slovenščina',
    key: 'sl',
  },
  {
    id: 23,
    label: 'Slovenčina',
    key: 'sk',
  },
  {
    id: 24,
    label: 'Srpski',
    key: 'sr',
  },
  {
    id: 25,
    label: 'Türkçe',
    key: 'tr',
  },
  {
    id: 26,
    label: 'Українська',
    key: 'uk',
  },
  {
    id: 27,
    label: '한국어',
    key: 'ko',
  },
  {
    id: 28,
    label: '繁體中文',
    key: 'zh_TW',
  },
  {
    id: 29,
    label: 'ภาษาไทย',
    key: 'th',
  },
  {
    id: 30,
    label: 'Tiếng Việt',
    key: 'vi',
  },
  {
    id: 31,
    label: '日本語',
    key: 'ja',
  },
  {
    id: 32,
    label: 'עברית',
    key: 'he',
  },
  {
    id: 33,
    label: 'Português(Brasil)',
    key: 'pt_BR',
  },
  {
    id: 34,
    label: 'العربية',
    key: 'ar',
  },
  {
    id: 35,
    label: 'فارسی',
    key: 'fa',
  },
  {
    id: 36,
    label: 'Bahasa Indonesia',
    key: 'in',
  },
  {
    id: 37,
    label: 'O‘zbekcha',
    key: 'uz',
  },
  {
    id: 38,
    label: 'Қазақша',
    key: 'kk',
  },
  {
    id: 39,
    label: '简体中文',
    key: 'zh_CN',
  },
]

export const useSelectLanguage = () => {
  const { locale } = useI18n()
  const langLabel = computed(() => {
    const langItem = LanguageOption.find((item) => item.key === locale.value)
    return langItem.label
  })

  const selectLanguage = async (langKey) => {
    await loadLocale(langKey)
    locale.value = langKey
  }

  return {
    selectLanguage,
    langLabel,
    key: locale,
  }
}
